// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-GCDsX";
var _3 = "button-1LcEc";
var _4 = "button_delete-3M3CK";
export { _1 as "__esModule", _2 as "container", _3 as "button", _4 as "button_delete" }
export default { "__esModule": _1, "container": _2, "button": _3, "button_delete": _4 }
